import getIncludedResource from '../../helpers/getIncludedResource';

const getFormattedInsurers = (commissions, insurers) => {
  return insurers?.map((product) => {
    const insurers = Object.values(product.insurers);
    return {
      product: product.id,
      rates: insurers.map((insurer) => {
        const insurerCommission = commissions.find((commission) => {
          return (
            commission.insurer === insurer.code && commission.product_id === product.id
          );
        });

        return {
          insurer: insurer.code,
          name: insurer.name,
          logo: insurer.logo,
          max_commission: insurer.max_commission,
          enabled: !!insurerCommission,
          rate: insurerCommission?.rate,
        };
      }),
    };
  });
};

const getActiveCommissions = (resource) => {
  if (!resource) {
    return [];
  }
  const commissions = getIncludedResource(
    resource.data,
    resource.included,
    'active_commissions',
  );
  return commissions
    ?.filter((commission) => commission.relationships.insurer.data)
    .map((commission) => {
      const product = getIncludedResource(commission, resource.included, 'product');
      return {
        insurer: commission.relationships.insurer.data.id,
        rate: commission.attributes.rate,
        product_id: product.data.id,
      };
    });
};

const getAvailableProducts = (user) => {
  if (!user) {
    return [];
  }
  return getIncludedResource(user.data, user.included, 'available_products')?.map(
    (product) => ({
      id: product.id,
      name: product.attributes.name,
    }),
  );
};
export { getFormattedInsurers, getActiveCommissions, getAvailableProducts };
